import React from 'react';
import LoadingSpinner from '@/components/ui/loading-spinner';

interface TableStateGateProps {
  isLoading: boolean;
  /** Truthy renders `errorMessage` instead of children — pass the query's raw error object. */
  error: unknown;
  isEmpty: boolean;
  errorMessage: string;
  emptyMessage: string;
  children: React.ReactNode;
}

/**
 * Standardizes the loading/error/empty/data branch every index table page
 * (Studies, Sites, ...) renders around its `<DataTable>` — checked in that
 * order: loading first, then error, then empty, else `children`.
 */
export const TableStateGate: React.FC<TableStateGateProps> = ({
  isLoading,
  error,
  isEmpty,
  errorMessage,
  emptyMessage,
  children,
}) => {
  if (isLoading) {
    return (
      <div className="px-8">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500 text-center p-8">{errorMessage}</div>;
  }

  if (isEmpty) {
    return <div className="text-center py-8 text-gray-500">{emptyMessage}</div>;
  }

  return <>{children}</>;
};
